import styled, {css} from 'styled-components/native';
import {RFPercentage, RFValue} from 'react-native-responsive-fontsize';
import Modal from 'react-native-modal';
import Feather from 'react-native-vector-icons/Feather';
import {getStatusBarHeight, isIphoneX} from 'react-native-iphone-screen-helper';
import {Dimensions} from 'react-native';
import FastImage from 'react-native-fast-image';

const imageDimensions = isIphoneX()
  ? Dimensions.get('window').width >= 393 &&
    Dimensions.get('window').width < 430
    ? RFValue(46)
    : Dimensions.get('window').width >= 394 &&
      Dimensions.get('window').width < 431
    ? RFValue(50)
    : RFValue(56)
  : RFValue(60);

interface ICategoryProductProps {
  inactive?: boolean;
}

// @ts-ignore
export const Container = styled(Modal)`
  justify-content: flex-end;
  margin: 0;
`;

export const CloseButton = styled.TouchableOpacity`
  position: absolute;
  top: ${RFValue(4)}px;
  right: 24px;
  z-index: 10;
`;
export const CloseButtonIcon = styled(Feather)`
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(18)}px;
`;

export const ModalContent = styled.View`
  background-color: ${({theme}) => theme.colors.background};
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  width: 100%;
`;

export const ModalBody = styled.View`
  padding: 0 24px;
  margin-top: ${RFValue(12)}px;
  margin-bottom: ${RFValue(16)}px;
`;

export const ModalInfos = styled.View`
  margin-bottom: ${RFValue(12)}px;
`;

export const ModalTitle = styled.Text`
  font-size: ${RFValue(14)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.title};
  z-index: 201;
`;

export const ModalSubtitle = styled.Text`
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text};
  z-index: 201;
`;

export const ModalFooter = styled.View`
  padding: 0 24px;
  padding-bottom: ${RFValue(16)}px;
`;

export const ProductCategoryItem = styled.TouchableOpacity<ICategoryProductProps>`
  width: 50%;
  margin-bottom: ${RFValue(8)}px;
  ${({inactive}) =>
    inactive &&
    css`
      opacity: 0.2;
    `}
`;

export const ProductMask = styled.View`
  height: ${imageDimensions}px;
  width: 100%;
  background-color: #000;
  position: absolute;
  opacity: 0.15;
  z-index: 1;

  border-radius: ${RFValue(6)}px;
`;

export const ProductCategoryInfos = styled.View`
  position: absolute;
  margin: ${RFValue(6)}px;
  z-index: 2;
`;

// @ts-ignore
export const ProductCategoryImage = styled(FastImage)`
  height: ${imageDimensions}px;
  border-radius: ${RFValue(6)}px;
`;

export const ProductTypeName = styled.Text`
  color: ${({theme}) => theme.colors.shape};
  font-size: ${RFValue(12)}px;
  flex: 1;
  font-family: ${({theme}) => theme.fonts.bold};
`;
